/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SwapRequestResponseItem } from './swap-request-response-item';


export interface SwapRequestResponseItemPagedList { 
    totalCount?: number;
    items?: Array<SwapRequestResponseItem> | null;
}

